import { render } from "./GroupOnlyButton.vue?vue&type=template&id=e3074628&scoped=true"
import script from "./GroupOnlyButton.vue?vue&type=script&lang=js"
export * from "./GroupOnlyButton.vue?vue&type=script&lang=js"

import "./GroupOnlyButton.vue?vue&type=style&index=0&id=e3074628&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3074628"]])

export default __exports__